import { render, staticRenderFns } from "./upload-attachment-summary.vue?vue&type=template&id=4f2a125d&"
import script from "./upload-attachment-summary.vue?vue&type=script&lang=js&"
export * from "./upload-attachment-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports